import { useFetch } from "./utils";
import { visionURL } from "../config/environment";
import { deserialize } from "../redux/utils/jsona";

export const useReport = (reportName, params = null) => {
  const apiUrl = `${visionURL}/admin_console/api/administration/report_path/?name=${reportName}`;
  const report_response = useFetch(apiUrl);
  const report_path = report_response ? deserialize(report_response) : false;
  const report = () => {
    const reportUrl = `${visionURL}${report_path.reportPath}${getFiltersString(
      params
    )}`;
    var win = window.open(reportUrl, "_blank");
    win.focus();
  };
  return report_path ? report : report_path;
};

const getFiltersString = params => {
  let filter = "";
  if (params) {
    if (params.filters || params.invoke) filter += "?";
    const filtersArray = [];
    if (params.filters) {
      for (const [key, value] of Object.entries(params.filters)) {
        if (value !== null) filtersArray.push(`filter[${key}]=${value}`);
      }
    }
    if ("invoke" in params) {
      filtersArray.push(`invoke=${params.invoke}`);
    }
    filter += filtersArray.join("&");
  }
  return filter;
};
